var map = {
	"./cku.png": 1016,
	"./cnnu.png": 5223,
	"./csu.png": 9024,
	"./dku.png": 1899,
	"./dsu.png": 931,
	"./dswu.png": 6824,
	"./gcu.png": 364,
	"./hbu.png": 9264,
	"./hgu.png": 6739,
	"./hsu.png": 9359,
	"./ihu.png": 6487,
	"./kmu.png": 9906,
	"./ku.png": 4087,
	"./kyu.png": 9006,
	"./schu.png": 4556,
	"./scnu.png": 4726,
	"./sju.png": 7735,
	"./skku.png": 9401,
	"./skmu.png": 4367,
	"./smu.png": 9930,
	"./wku.png": 2324,
	"./wsu.png": 6860,
	"./ynu.png": 865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2816;